import mutations from './mutations'
import * as actions from './actions'
import * as getters from './getters'

const initialState = {
    perimeters: [],
    main_perimeters: [],
    user_right: [],
    user_assign: []
}

export default {
    namespaced: true,

    state: initialState,

    getters: getters,

    actions: actions,

    mutations: mutations
}
